import React from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../translation/namespace';
import { AcceptDeclineForm, SonForm } from '../../../_lib/Form2';
import { AnyParameter } from '../../../_lib/Form2/types/SonForm';

type AppLibraryDeleteForm = {
  form: SonForm<AnyParameter>;
  refresh(): void;
};

export function AppLibraryDeleteForm({ form, refresh }: AppLibraryDeleteForm) {
  const { t } = useTranslation(Namespace.AppLibrary);

  return (
    <AcceptDeclineForm
      form={form}
      headline={t('deleteForm.question')}
      onSuccess={refresh}
      messageSuccess={t('deleteForm.status.success')}
      messageSending={t('deleteForm.status.sending')}
      messageFail={t('deleteForm.status.fail')}
    />
  );
}
